import en from './en';
import es from './es';
import fr from './fr';
import ja from './ja';
import zh from './zh';

export const resources = {
  en,
  es,
  fr,
  ja,
  zh
};

export default resources; 